import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./FinBenefits.css";

export default function FinBenefits({ imageSrc }) {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="fin-benefits-section" id="benefits">
      <div className="fin-benefits-content">
        <div className="fin-benefits-text" data-aos="fade-right">
          <div className="fin-benefits-title">
            DIGITAL ACCELERATION<br />
            <span className="fin-benefits-title-blue">IN FINTECH</span>
          </div>
          <div className="fin-benefits-desc">
            Digital acceleration is the heartbeat of Fintech evolution. Embrace the future with our digital acceleration strategies that propel your financial institution into the realms of speed, efficiency, and innovation. Embrace digital finance, and propel your institution into a new era of financial services. Our digital acceleration strategies are tailored to meet the demands of today’s fast-paced Fintech landscape.
          </div>
          <button className="fin-benefits-btn" data-aos="fade-up" data-aos-delay="200">
            MORE ABOUT DIGITAL ACCELERATION
          </button>
        </div>
        <div className="fin-benefits-image" data-aos="fade-left">
          <img src={imageSrc} alt="Digital Acceleration" />
        </div>
      </div>
    </section>
  );
}